import { baseApiUrl } from 'src/config';
import { DocumentServiceFieldsResponse } from './types';
import { getAccessToken } from 'src/routes/AuthContext';

export const getFields = async (
  realm: string,
  formId: string,
  uuid: string
): Promise<DocumentServiceFieldsResponse> => {
  const formData = new FormData();
  formData.append('webhookUuid', uuid);

  const token = await getAccessToken();
  return fetch(`${baseApiUrl}/document/form/get/${formId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': realm,
    },
    body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((fieldData) => {
      return fieldData;
    })
    .catch((error) => {
      throw Error(`Error fetching form fields: ${error}`);
    });
};
